import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared/shared.module';
import { ToggleAllOptionsComponent } from './shared/toggle-all-options/toggle-all-options.component';
import { WhatsappTemplateCategoryComponent } from './whatsapp-template/whatsapp-template-category/whatsapp-template-category.component';
import { WhatsappTemplateLanguagesComponent } from './whatsapp-template/whatsapp-template-languages/whatsapp-template-languages.component';
import { WhatsappTemplateMediaHeaderComponent } from './whatsapp-template/whatsapp-template-languages/whatsapp-template-media-header/whatsapp-template-media-header.component';
import { WhatsappTemplateMainComponent } from './whatsapp-template/whatsapp-template-main/whatsapp-template-main.component';
import { WhatsappTemplateScenariosDependenciesComponent } from './whatsapp-template/whatsapp-template-scenarios-dependencies/whatsapp-template-scenarios-dependencies.component';
import { WhatsappTemplateComponent } from './whatsapp-template/whatsapp-template.component';
import { WhatsappTemplatesComponent } from './whatsapp-templates.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    WhatsappTemplateComponent,
    WhatsappTemplateMainComponent,
    WhatsappTemplateCategoryComponent,
    WhatsappTemplateLanguagesComponent,
    ToggleAllOptionsComponent,
    WhatsappTemplateMediaHeaderComponent,
    WhatsappTemplateScenariosDependenciesComponent,
    WhatsappTemplatesComponent,
  ],
  exports: [WhatsappTemplatesComponent],
})
export class WhatsappTemplatesModule {}
